<div class="developer-guide-container">
  <div class="header-section">
    <h1>Developer Integration Guide</h1>
    <p class="subtitle">Learn how to integrate Consent Wallet SDK into your application</p>
  </div>

  <div class="content-section">
    <!-- Loading state -->
    <div *ngIf="isLoading" class="loading-section">
      <p>Loading developer guide...</p>
    </div>

    <!-- Markdown content using ngx-markdown -->
    <div *ngIf="!isLoading" class="markdown-content">
      <markdown [data]="markdownContent"></markdown>
    </div>
  </div>
</div>
